module.exports = __webpack_public_path__ + "img/251.79d0b8c9.jpg";